
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Legal = lazy(() => import('../pages/legal/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/legal',
    element: <Legal />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
